let html = `<div class="cub-premium cub-premium--detail">
    <div class="cub-premium__icon selector">
        <svg height="187" viewBox="0 0 316 187" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M88.4999 13C53.2999 22.9999 31.3598 46.5 21.4999 60C11.6399 73.5 -3.206 102.466 0.96966 127.865C5.14532 153.264 21.5725 177.152 46.8782 184.993C72.1839 192.834 91.4738 170.655 127.498 167.07C163.522 163.486 196.2 182.884 227 167.07C257.8 151.256 286.5 119.814 281.5 88.0003C276.5 56.1863 240.6 23.0003 202 8.00027C163.4 -6.99978 123.7 3.00007 88.4999 13Z" fill="#D8C39A" fill-opacity="0.07"/>
        <path d="M100.284 7.20609C66.0842 10.3061 33.4999 30 16.2843 54.7061C6.77178 68.3574 -10.7157 114.706 19.7843 139.706C50.2843 164.706 120.584 182.906 175.284 183.706C229.984 184.506 267.884 172.706 293.284 143.706C318.684 114.706 322.184 58.8061 302.284 38.7061C282.384 18.6061 234.184 49.5061 193.784 43.2061C153.384 36.9061 134.484 4.10609 100.284 7.20609Z" fill="#D8C39A" fill-opacity="0.07"/>
        <path d="M44.8938 12.0212C18.7938 24.6211 7.88042 62.3671 13.3938 97.5212C21.5109 149.278 76 165.788 122.894 175.021C164.5 183.214 224.394 177.121 257.894 160.521C291.394 143.921 293.594 117.221 290.394 92.0213C287.194 66.8214 271.194 46.0213 241.894 34.5213C212.594 23.0214 183.294 39.0215 143.894 34.5214C104.494 30.0214 70.9938 -0.578779 44.8938 12.0212Z" fill="#D8C39A" fill-opacity="0.07"/>
        <circle cx="52.9634" cy="57.9635" r="4.96348" stroke="#D8C39A" stroke-width="4"/>
        <circle cx="45.9634" cy="168.963" r="4.96348" stroke="#D8C39A" stroke-width="4"/>
        <circle cx="280.005" cy="111.937" r="3.13098" stroke="#D8C39A" stroke-width="4"/>
        <rect x="200" y="158.131" width="13.927" height="3.66499" rx="1.83249" fill="#D8C39A"/>
        <rect x="205.131" y="166.927" width="13.927" height="3.66499" rx="1.83249" transform="rotate(-90 205.131 166.927)" fill="#D8C39A"/>
        <rect x="237" y="39.5908" width="12.461" height="3.2792" rx="1.6396" fill="#D8C39A"/>
        <rect x="241.591" y="47.4609" width="12.461" height="3.2792" rx="1.6396" transform="rotate(-90 241.591 47.4609)" fill="#D8C39A"/>
        <rect x="167" y="28.7808" width="10.262" height="2.70052" rx="1.35026" fill="#D8C39A"/>
        <rect x="170.781" y="35.2622" width="10.262" height="2.70052" rx="1.35026" transform="rotate(-90 170.781 35.2622)" fill="#D8C39A"/>
        <rect x="49.1107" y="124.513" width="10.262" height="2.70052" rx="1.35026" fill="#D8C39A"/>
        <rect x="52.8914" y="130.995" width="10.262" height="2.70052" rx="1.35026" transform="rotate(-90 52.8914 130.995)" fill="#D8C39A"/>
        </svg>

        <span>CUB Premium</span>
    </div>
    <div class="cub-premium__descr">
        #{account_premium}
    </div>
    <div class="cub-premium__includes">
        <div class="selector">
            <div>#{account_premium_include_1}<span>#{account_premium_include_text_1}</span></div>
            <div>#{filter_rating_from} 360 #{filter_rating_to} 5 040</div>
        </div>
        <div class="selector">
            <div>#{account_premium_include_2}<span>#{account_premium_include_text_2}</span></div>
            <div>#{filter_rating_from} 100 #{filter_rating_to} 500</div>
        </div>
        <div class="selector">
            <div>#{account_premium_include_3}<span>#{account_premium_include_text_3}</span></div>
            <div>#{filter_rating_from} 1 000 #{filter_rating_to} 10 000</div>
        </div>
        <div class="selector">
            <div>#{account_premium_include_4}<span>#{account_premium_include_text_4}</span></div>
            <div>#{filter_rating_from} 3 #{filter_rating_to} 8</div>
        </div>
        <div class="selector">
            <div>#{account_premium_include_5}<span>#{account_premium_include_text_5}</span></div>
            <div></div>
        </div>
        <div class="selector">
            <div>#{account_premium_include_6}<span>#{account_premium_include_text_6}</span></div>
            <div></div>
        </div>
    </div>
    <div class="cub-premium__descr">#{account_premium_more}</div>
    <div class="cub-premium__url selector">{site}/premium</div>
</div>`

export default html